import React from 'react';
import {styles} from './styles';
import ValueController from './valueController';

export default function DimensionController({initialValue = 0, onUpdate}) {
  return (
    <ValueController
      initialValue={initialValue}
      onUpdate={onUpdate}
      minValue={0.1}
      maxValue={99.9}
      allowDecimals={true}
      step={0.1}
      containerStyle={styles.dimensionCountContainer}
      inputStyle={styles.dimensionCountInput}
      testIdPrefix="dimension"
    />
  );
}
